module.exports = __webpack_public_path__ + "media/images/menu-icons/photos-eb63eeb76d4ad6008faff2a2e45ff916.svg";